import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import BlankLayout from "@core/layouts/BlankLayout";

import FooterIllustrations from "views/pages/auth/FooterIllustrations";
import { Link } from "react-router-dom";

const BoxWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    width: "90vw",
  },
}));

const Img = styled("img")(({ theme }) => ({
  marginTop: theme.spacing(15),
  marginBottom: theme.spacing(15),
  [theme.breakpoints.down("lg")]: {
    height: 450,
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(10),
  },
  [theme.breakpoints.down("md")]: {
    height: 400,
  },
}));

const Error404 = () => {
  return (
    <BlankLayout>
      <Box className="content-center">
        <Box
          sx={{
            p: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <BoxWrapper>
            <Typography variant="h1" sx={{ mb: 2.5 }}>
              404
            </Typography>
            <Typography
              variant="h5"
              sx={{
                mb: 2.5,
                letterSpacing: "0.18px",
                fontSize: "1.5rem !important",
                color: "white",
              }}
            >
              Page Not Found ⚠️
            </Typography>
            <Typography variant="body2" sx={{ color: "white" }}>
              We couldn&prime;t find the page you are looking for.
            </Typography>
          </BoxWrapper>
          <Img alt="error-illustration" src="/images/pages/404.png" />
          <Link style={{ textDecoration: "none" }} to="/announcement">
            <Button variant="contained" sx={{ px: 5.5 }}>
              Back to Home
            </Button>
          </Link>
        </Box>
        <FooterIllustrations image="/images/pages/misc-404-object.png" />
      </Box>
    </BlankLayout>
  );
};

export default Error404;
